import { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { usePwaInstallContext } from '../../context/PwaInstallContext'
import { getRole } from '../../utils/getRole'
import {
  getCurrentPushSubscription,
  getPushPermissionState,
  isIosWithoutInstalledPwa,
  isWebPushSupported,
  showLocalTestNotification,
  subscribeToWebPush,
  unsubscribeFromWebPush,
  type PushPermissionState,
} from '../../utils/webPush'
import styles from './WebPushSettings.module.css'

function WebPushSettings() {
  const { isClient } = getRole()
  const { showInstallButton, openInstall } = usePwaInstallContext()
  const [permission, setPermission] = useState<PushPermissionState>('default')
  const [subscribed, setSubscribed] = useState(false)
  const [busy, setBusy] = useState(false)

  const refresh = useCallback(async () => {
    if (!isWebPushSupported()) {
      setPermission('unsupported')
      setSubscribed(false)
      return
    }

    const nextPermission = await getPushPermissionState()
    const subscription = await getCurrentPushSubscription()
    setPermission(nextPermission)
    setSubscribed(Boolean(subscription))
  }, [])

  useEffect(() => {
    refresh()
  }, [refresh])

  if (isClient) {
    return null
  }

  const handleEnable = async () => {
    setBusy(true)
    try {
      await subscribeToWebPush()
      toast.success('Уведомления включены')
      await refresh()
    } catch (error: any) {
      const status = error?.response?.status
      if (status === 404) {
        toast.warning(
          'Бэкенд ещё не отдал VAPID-ключ или POST /api/push/subscribe. Локальный баннер можно проверить кнопкой «Проверить».'
        )
        await refresh()
      } else {
        toast.error(
          error?.response?.data?.message ||
            error?.message ||
            'Не удалось включить уведомления'
        )
      }
    } finally {
      setBusy(false)
    }
  }

  const handleDisable = async () => {
    setBusy(true)
    try {
      await unsubscribeFromWebPush()
      toast.success('Уведомления выключены')
      await refresh()
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Не удалось выключить уведомления'
      )
    } finally {
      setBusy(false)
    }
  }

  const handleTest = async () => {
    setBusy(true)
    try {
      await showLocalTestNotification()
    } catch (error: any) {
      toast.error(error?.message || 'Не удалось показать уведомление')
    } finally {
      setBusy(false)
    }
  }

  const iosNeedsPwa = isIosWithoutInstalledPwa()

  return (
    <></>
    // <div className={styles.section}>
    //   <small className={styles.title}>Push-уведомления</small>

    //   {!isWebPushSupported() ? (
    //     <p className={styles.hint}>
    //       Этот браузер не поддерживает web-push. Нужен HTTPS и современный
    //       Chrome, Firefox, Edge или установленное приложение на iPhone.
    //     </p>
    //   ) : iosNeedsPwa ? (
    //     <>
    //       <p className={styles.hint}>
    //         На iPhone уведомления работают только после установки на домашний
    //         экран: «Поделиться» → «На экран Домой». Затем откройте Alex с
    //         иконки и включите уведомления здесь.
    //       </p>
    //       {showInstallButton && (
    //         <div className={styles.actions}>
    //           <button
    //             type="button"
    //             className={styles.btn}
    //             onClick={() => openInstall()}
    //           >
    //             Как установить
    //           </button>
    //         </div>
    //       )}
    //     </>
    //   ) : permission === 'denied' ? (
    //     <p className={styles.hint}>
    //       Уведомления запрещены в настройках браузера. Разрешите их для этого
    //       сайта и обновите страницу.
    //     </p>
    //   ) : (
    //     <>
    //       <p className={styles.status}>
    //         {subscribed
    //           ? 'Статус: включены на этом устройстве'
    //           : 'Статус: выключены'}
    //       </p>
    //       <p className={styles.hint}>
    //         Системные уведомления приходят, даже если вкладка закрыта. На
    //         Android работают в браузере и с ярлыка, на iPhone — только из
    //         установленного приложения.
    //       </p>
    //       <div className={styles.actions}>
    //         {subscribed ? (
    //           <button
    //             type="button"
    //             className={`${styles.btn} ${styles.btnSecondary}`}
    //             disabled={busy}
    //             onClick={handleDisable}
    //           >
    //             Выключить
    //           </button>
    //         ) : (
    //           <button
    //             type="button"
    //             className={styles.btn}
    //             disabled={busy}
    //             onClick={handleEnable}
    //           >
    //             Включить уведомления
    //           </button>
    //         )}
    //         <button
    //           type="button"
    //           className={`${styles.btn} ${styles.btnSecondary}`}
    //           disabled={busy}
    //           onClick={handleTest}
    //         >
    //           Проверить
    //         </button>
    //       </div>
    //     </>
    //   )}
    // </div>
  )
}

export default WebPushSettings
